module.exports = __webpack_public_path__ + "img/ZA.9a96517c.svg";